
const ActivitiesSection = () => {
  const activities = [
    {
      title: '健康體適能',
      description: '每日晨間運動，維持身體機能',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/7b9e3505c54f6cd64e49fc46676edb6e.png',
      tag: '運動',
      alt: '高雄前金日照中心健康體適能活動 - 長者晨間運動課程',
    },
    {
      title: '手工藝創作',
      description: '激發創意，訓練手部精細動作',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/9c8756a6c94897d3fa510ce6b9746f47.jpeg',
      tag: '創作',
      alt: '前金日間照顧中心手工藝創作活動 - 長者藝術創作課程',
    },
    {
      title: '音樂律動',
      description: '透過音樂活化身心，帶來歡樂',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/d0fa1e8dd794910e9d8983e427855f7e.jpeg',
      tag: '音樂',
      alt: '高雄前金日照音樂律動課程 - 長者音樂治療活動',
    },
    {
      title: '認知訓練',
      description: '益智遊戲，延緩認知退化',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/6742fcecc320d4310be97e6bb7044822.jpeg',
      tag: '益智',
      alt: '前金日照中心認知訓練課程 - 失智症預防益智遊戲',
    },
    {
      title: '家屬座談及失智講座',
      description: '專業講座與家屬交流，共同關懷長者',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/3dc51560b592de7c17c7fb7e5ff1b31f.jpeg',
      tag: '講座',
      alt: '高雄前金日照家屬座談會 - 失智症照護專業講座',
    },
    {
      title: '長照諮詢',
      description: '專業一對一諮詢，解答照護疑問',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/7841755fd33fafa9f4b5508089b5cd2e.jpeg',
      tag: '諮詢',
      alt: '前金日間照顧中心長照諮詢服務 - 專業照護顧問',
    },
    {
      title: '義剪服務',
      description: '志工免費理髮，讓長者容光煥發',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/768a11162595cf6492f18a1d0a22da0e.jpeg',
      tag: '服務',
      alt: '高雄前金日照義剪服務 - 長者免費理髮志工服務',
    },
    {
      title: '園藝療癒',
      description: '多肉植物手作，療癒身心靈',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/d0fd6a9f8fd68e1b0a34c75782cee606.jpeg',
      tag: '療癒',
      alt: '前金日照中心園藝療癒課程 - 長者多肉植物手作活動',
    },
    {
      title: '家屬聯繫',
      description: '定期與家屬溝通，共同關心長者',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/8b04961be8fe30c67ee9072be370ad3f.jpeg',
      tag: '關懷',
      alt: '前金日照中心家屬聯繫服務 - 工作人員與長者家屬溝通交流',
    },
    {
      title: '節慶活動',
      description: '歡樂變裝派對，讓長者開心過節',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/3c6201a2a8d913bdec7b00b016fb9f14.jpeg',
      tag: '歡樂',
      alt: '前金日照中心節慶活動 - 長者與工作人員變裝派對歡樂慶祝',
    },
    {
      title: '協助預防針施打',
      description: '專業護理人員協助長者施打預防針',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/030be2ec2c96edb66e4d609a9c055af5.jpeg',
      tag: '健康',
      alt: '前金日照中心協助預防針施打 - 專業護理人員為長者施打疫苗',
    },
  ];

  return (
    <section id="activities" className="py-24 bg-gradient-to-b from-baby-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <div className="inline-flex items-center gap-2 bg-baby-blue-100 px-4 py-2 rounded-full mb-6">
              <i className="ri-calendar-event-line text-baby-blue-500"></i>
              <span className="text-sm font-medium text-baby-blue-600">活動內容</span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-baby-blue-600">
              生活照顧點點滴滴
            </h3>
          </div>
          <p className="text-gray-500 mt-4 md:mt-0 max-w-md">
            豐富多元的日常活動安排，讓長者每天都充實快樂
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {activities.map((activity, index) => (
            <div
              key={index}
              className="group relative rounded-3xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[4/5] relative">
                <img
                  src={activity.image}
                  alt={activity.alt}
                  title={`${activity.title} - 前金日間照顧中心`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <div className="absolute top-4 left-4">
                  <span className="bg-cream-300 text-baby-blue-600 px-3 py-1 rounded-full text-xs font-medium">
                    {activity.tag}
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h4 className="text-white font-bold text-lg mb-1">{activity.title}</h4>
                  <p className="text-white/80 text-sm">{activity.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSection;
